module.exports = __webpack_public_path__ + "media/project_quote/close-ico-5160bafd.svg";